<template>
  <div class="support-value">
    <span class="support-value__text" :dir="ltr ? 'ltr' : 'auto'">{{ value }}</span>
    <button type="button" :disabled="disabled" @click="$emit('action')">{{ action }}</button>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  value: string
  action: string
  disabled?: boolean
  ltr?: boolean
}>(), {
  disabled: false,
  ltr: false,
})

defineEmits<{ (event: 'action'): void }>()
</script>

<style scoped lang="scss">
.support-value {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 38px;
  min-width: 0;
  align-items: center;
  gap: 8px;
  padding: 0 6px 0 12px;
  border-radius: 8px;
  background: #f7f9fc;
}

.support-value__text {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  color: #1f2329;
  font-size: 12.5px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

button {
  box-sizing: border-box;
  height: 28px;
  flex: 0 0 auto;
  padding: 0 12px;
  border: 1px solid #a9cbf5;
  border-radius: 6px;
  background: #fff;
  color: #2f80ed;
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  font-weight: 600;

  &:hover:not(:disabled) {
    background: #f5f9ff;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
}

:dir(rtl) .support-value {
  padding: 0 12px 0 6px;
}
</style>
